import {
  PRICELIST_CASE_FILE_ATTACHED_ACTION_KEY,
  PRICELIST_CASE_FILE_DEPRECATED_ACTION_KEY,
  PRICELIST_CASE_FILE_DETACHED_ACTION_KEY,
  PRICELIST_CASE_FILE_NOTES_CHANGED_ACTION_KEY,
  PRICELIST_CASE_FILE_REINSTATED_ACTION_KEY,
} from '@erp/shared-types';

export type PricelistCaseFileHistoryKind =
  'attached' | 'detached' | 'notes_changed' | 'deprecated' | 'reinstated';

export function classifyPricelistCaseFileAction(
  actionKey: string,
): PricelistCaseFileHistoryKind | null {
  switch (actionKey) {
    case PRICELIST_CASE_FILE_ATTACHED_ACTION_KEY:
      return 'attached';
    case PRICELIST_CASE_FILE_DETACHED_ACTION_KEY:
      return 'detached';
    case PRICELIST_CASE_FILE_NOTES_CHANGED_ACTION_KEY:
      return 'notes_changed';
    case PRICELIST_CASE_FILE_DEPRECATED_ACTION_KEY:
      return 'deprecated';
    case PRICELIST_CASE_FILE_REINSTATED_ACTION_KEY:
      return 'reinstated';
    default:
      return null;
  }
}

interface FileHistoryPayload {
  documentId?: unknown;
  notes?: unknown;
  previousNotes?: unknown;
}

function isFileHistoryPayload(payload: unknown): payload is FileHistoryPayload {
  return payload !== null && typeof payload === 'object';
}

function asOptionalString(value: unknown): string | null {
  if (value === null || value === undefined) return null;
  return typeof value === 'string' ? value : null;
}

export function payloadDocumentId(payload: unknown): string | null {
  if (!isFileHistoryPayload(payload)) return null;
  return asOptionalString(payload.documentId);
}

export function payloadNoteValue(
  payload: unknown,
  key: 'notes' | 'previousNotes',
): string | null {
  if (!isFileHistoryPayload(payload)) return null;
  return asOptionalString(payload[key]);
}
